import React from 'react';
import { Button, DialogActions, DialogContent, Dialog, DialogContentText, CircularProgress, styled } from '@mui/material';
import { Progress } from 'models';

const Center = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

export interface ProgressDialogProps {
    onClose?: () => void;
    progress: Progress;
}

export function ProgressDialog(props: ProgressDialogProps) {
    const { progress } = props;

    function handleClose() {
        if (props.onClose) {
            props.onClose();
        }
    }

    return (
        <Dialog open={true} fullWidth>
            <DialogContent>
                <Center>
                    {!progress.isComplete && <CircularProgress />}
                </Center>
                <br />
                <Center>
                    <DialogContentText>
                        {progress.status}
                    </DialogContentText>
                </Center>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary" disabled={!progress.isComplete}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}